/* cords2-count.js - figures that count up, 27 October 2026.

   Viktor, after curamando.com: "I like numbers that are counting up." A
   figure counts from zero to its value once, the first time most of it is
   on screen, over 1.4 seconds, fast at first and slowing to a stop.

   THE PAGE HOLDS THE REAL NUMBER. snippets/cords2-count.liquid prints the
   final value twice: once hidden from the eye, for screen readers and
   search, and once aria-hidden, which is the copy this script animates.
   Without this script, with reduced motion, or for a figure already on
   screen when the page opens, the final value simply stands.

   The animated copy is held at the width of its final value, measured in
   the page before it is set to zero, so the unit after it never moves while
   the digits change. Proportional figures, not tabular: the display serif's
   tabular digits set 165 as 1 6 5. */
(function () {
  if (window.__c2count) return;
  window.__c2count = true;
  var DUR = 1400;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(el, v) {
    var d = parseInt(el.getAttribute('data-c2-dec'), 10) || 0;
    el.textContent = v.toFixed(d);
  }
  function run(el) {
    var end = parseFloat(el.getAttribute('data-c2-count'));
    var start = null;
    function step(t) {
      if (start === null) start = t;
      var k = Math.min(1, (t - start) / DUR);
      var e = 1 - Math.pow(1 - k, 3);
      if (k < 1) { show(el, end * e); window.requestAnimationFrame(step); }
      else { el.textContent = el.getAttribute('data-c2-final'); }
    }
    window.requestAnimationFrame(step);
  }
  function init(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = Array.prototype.slice.call((scope || document).querySelectorAll('[data-c2-count]:not([data-c2-armed])'));
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { io.unobserve(en.target); run(en.target); }
      });
    }, { threshold: 0.6 });
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      el.setAttribute('data-c2-armed', '');
      var end = parseFloat(el.getAttribute('data-c2-count'));
      if (isNaN(end)) return;
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) return; /* already in view: leave it */
      el.setAttribute('data-c2-final', el.textContent);
      el.style.display = 'inline-block';
      el.style.minWidth = Math.ceil(r.width) + 'px';
      show(el, 0);
      io.observe(el);
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
